/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_Frame_RateInputs */

const en_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Frame Rate`)
};

const fr_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence d’images source`)
};

const de_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellbildrate`)
};

const it_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza fotogrammi sorgente`)
};

const ru_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исходная частота кадров`)
};

const es_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas de origen`)
};

const zh_cn2_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源帧速率`)
};

const ja_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースフレームレート`)
};

const hi_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत फ्रेम दर`)
};

const pt_pt2_source_frame_rate = /** @type {(inputs: Source_Frame_RateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros da fonte`)
};

/**
* | output |
* | --- |
* | "Source Frame Rate" |
*
* @param {Source_Frame_RateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const source_frame_rate = /** @type {((inputs?: Source_Frame_RateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Frame_RateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_source_frame_rate(inputs)
	if (locale === "de") return de_source_frame_rate(inputs)
	if (locale === "it") return it_source_frame_rate(inputs)
	if (locale === "ru") return ru_source_frame_rate(inputs)
	if (locale === "es") return es_source_frame_rate(inputs)
	if (locale === "zh-CN") return zh_cn2_source_frame_rate(inputs)
	if (locale === "ja") return ja_source_frame_rate(inputs)
	if (locale === "hi") return hi_source_frame_rate(inputs)
	if (locale === "pt-PT") return pt_pt2_source_frame_rate(inputs)
	return en_source_frame_rate(inputs)
});